import { executeRequest, JFSRequest } from '@jfs/network'
import { jsonToGraphQLQuery } from 'json-to-graphql-query'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  return response?.data?.data !== null
    ? response?.data?.data
    : response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.internalCode !== 909
    ? response?.data?.errors?.[0]?.exception?.emsErrorCodeDetailsDto?.channelDesc
    : response?.data?.errors?.[0]?.exception?.message ?? response?.data?.errors?.[0]?.message
}

const getDevicesRequestBody = (entityId: string) => {
  const queryObj = {
    findDevices: {
      __args: {
        entityId: entityId,
      },
      deviceDetails: {
        deviceSerialNo: true,
        deviceStatus: true,
        deviceLinkingStatus: true,
        manufacturerName: true,
        entityIdLinkDate: true,
      },
    },
  }

  const query = `{${jsonToGraphQLQuery(queryObj, { pretty: false })}}`
  console.log('fetchDevicesGqlReq query', query)
  return query
}

const fetchDevicesGqlReq = (entityId: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getDevicesGql),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: getDevicesRequestBody(entityId),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { fetchDevicesGqlReq }
